module.exports = __webpack_public_path__ + "img/icon-plus.7d181ac7.svg";